export const displayItemsCount = {
  tabletAndBelow: 6,
  desktop: 12
}
export const MENU_PAGES = {
  PARENT_CAT: 'parent_category',
  CHILD_CAT: 'child_category'
}
export const SORT_ORDER = {
  SORT_BY_DELIVERY_DATE: 'delivery_date_asc',
  SORT_BY_PRICE: 'unit_price_asc'
}
export const SORT_LABEL = {
  DELIVERY_DATE: 'Sort by Delivery Date',
  QUICK_DELIVERY: 'Sort by Quick Delivery',
  BUDGET: 'Sort by Budget',
  LOW_UNIT_PRICE: 'Sort by Low Unit Price'
}
export const CATEGORY_PRODUCTS_ENDPOINTS = '/products?category_id='
